<ng-container>
  <div class="flex justify-center graph-card">
    <div
      class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4 w-full max-w-6xl"
    >
      <ng-container *ngFor="let option of groupedData">
        <div
          class="border border-gray-200 rounded-xl p-3 flex items-start gap-3 hover:bg-secondary-active transition-shadow overflow-hidden"
        >
          <img
            [src]="getIcon(option.type)"
            class="mt-1 h-12 w-12 flex-shrink-0"
          />

          <div class="flex flex-col flex-1 min-w-0 overflow-hidden">
            <!-- NAME -->
            <span class="text-sm font-semibold text-gray-900 truncate">
              {{ option.name }}
            </span>

            <!-- COUNT + TYPE IN SINGLE LINE -->
            <div class="flex items-center gap-1 mt-1 min-w-0">
              <span class="text-xs text-gray-600 whitespace-nowrap">
                Total {{ option.itemcount }}
              </span>

              <span class="text-xs text-gray-500 truncate whitespace-nowrap">
                {{ option.type.split("/").pop() }}
              </span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
<div
  class="flex flex-1 items-center justify-center text-center flex-col graph-card"
  *ngIf="noData"
>
  <span class="text-md text-gray-900 font-medium">No Data Available</span>
  <span class="text-sm text-gray-800">There is no data to display yet</span>
</div>
